// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"27b48968","496":"e6a71e01"}[chunkId] + ".chunk.js";
};